<template>
  <div class="w-100 h-100">
    <div class="row g-1">
      <div class="col-12 col-md-4" v-for="summary in pavementSummary" :key="`chart-pavement-${summary.name}`">
        <div class="border h-100 p-3">
          <div class="card-header fw-bold text-uppercase mb-3">
            {{ summary.name }}
          </div>
          <div class="card-body row">
            <div class="col position-relative">
              <canvas :id="`chart-${summary.name}-work`" class="h-100 w-100"></canvas>
              <p class="mb-0 fw-bold fs-5 position-absolute top-50 start-50 translate-middle">
                {{
                  Math.ceil(
                    (summary.workExecutionActual /
                      summary.workExecutionPlanned) *
                    100
                  )
                    .toString()
                    .concat("%")
                }}
              </p>
            </div>
            <div class="col position-relative">
              <canvas :id="`chart-${summary.name}-allocation`" class="h-100 w-100"></canvas>
              <p class="mb-0 fs-5 fw-bold position-absolute top-50 start-50 translate-middle">
                {{
                  Math.ceil(
                    (summary.allocationActual / summary.allocationPlanned) * 100
                  )
                    .toString()
                    .concat("%")
                }}
              </p>
            </div>
          </div>
          <div class="w-100 border-top p-3 mt-3 d-flex justify-content-between align-items-start text-center">
            <div>
              <p class="text-secondary fw-bold lh-sm">Work Execution</p>
              <p class="mb-0">
                Planned:
                <span class="text-warning">
                  {{ summary.workExecutionPlanned }}
                </span>
              </p>
              <p class="mb-0">
                Actual:
                <span class="text-info">
                  {{ summary.workExecutionActual }}
                </span>
              </p>
            </div>
            <div>
              <p class="text-secondary fw-bold lh-sm">Allocation Usage</p>
              <p class="mb-0">
                Planned:
                <span class="text-warning">
                  {{ Helper.formatMoney(summary.allocationPlanned) }}
                </span>
              </p>
              <p class="mb-0">
                Actual:
                <span class="text-info">
                  {{ Helper.formatMoney(summary.allocationActual) }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  data() {
    return {
      pavementSummary: null,
    };
  },
  computed: {
    overall() {
      return {
        allocationActual: this.pavementSummary?.reduce((total, agency) => {
          return total + agency.allocationActual;
        }, 0),
        allocationPlanned: this.pavementSummary?.reduce((total, agency) => {
          return total + agency.allocationPlanned;
        }, 0),
        workExecutionActual: this.pavementSummary?.reduce((total, agency) => {
          return total + agency.workExecutionActual;
        }, 0),
        workExecutionPlanned: this.pavementSummary?.reduce((total, agency) => {
          return total + agency.workExecutionPlanned;
        }, 0),
      };
    },
  },
  methods: {
    async getPavementSummary() {
      this.Helper.toggleLoadingSpinner(true);

      this.API.getFromIraa(`statistics?filters[pavement_project]=2`)
        .then((res) => {
          const data = res.data.data.map((d) => d.attributes);

          let overallObj = {
            name: "overall",
            allocationActual: data?.reduce((total, agency) => {
              return total + agency.allocationActual;
            }, 0),
            allocationPlanned: data?.reduce((total, agency) => {
              return total + agency.allocationPlanned;
            }, 0),
            workExecutionActual: data?.reduce((total, agency) => {
              return total + agency.workExecutionActual;
            }, 0),
            workExecutionPlanned: data?.reduce((total, agency) => {
              return total + agency.workExecutionPlanned;
            }, 0),
          };

          this.pavementSummary = [overallObj, ...data];

          this.$nextTick(async () => {
            await this.createChart();

            this.Helper.toggleLoadingSpinner(false);
          });
        })
        .catch((e) => {
          console.error(e);

          this.Helper.toggleLoadingSpinner(false);
        });
    },
    async createChart() {
      const defaultConfig = {
        type: "doughnut",
        options: {
          cutout: "70%",
          responsive: false,
          maintainAspectRatio: true,
          plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
          },
          elements: {
            arc: { borderWidth: 0 },
          },
        },
      };

      this.pavementSummary.forEach((stats) => {
        const dataWork = {
          labels: ["Work Planned", "Work Actual"],
          datasets: [
            {
              label: `chart-${stats.name}-work`,
              data: [stats.workExecutionActual, stats.workExecutionPlanned],
              backgroundColor: ["rgb(54, 162, 235)", "rgb(255, 205, 86)"],
            },
          ],
        };

        const configWork = Object.assign({ data: dataWork }, defaultConfig);

        new Chart(
          document.getElementById(`chart-${stats.name}-work`),
          configWork
        );

        const dataAllocation = {
          labels: ["Allocation Planned", "Allocation Actual"],
          datasets: [
            {
              label: `chart-${stats.name}-allocation`,
              data: [stats.allocationActual, stats.allocationPlanned],
              backgroundColor: ["rgb(54, 162, 235)", "rgb(255, 205, 86)"],
            },
          ],
        };

        const configAllocation = Object.assign(
          { data: dataAllocation },
          defaultConfig
        );

        new Chart(
          document.getElementById(`chart-${stats.name}-allocation`),
          configAllocation
        );
      });
    },
  },
  mounted() {
    this.getPavementSummary();
  },
};
</script>